import { useCallback } from 'react';
import { useDetectHistoryNavigation } from 'common/hooks';
import { useFormInstance } from '../hooks';
import { Item } from '../item';

const ResetForm = () => {
  const form = useFormInstance();

  const handleReset = useCallback(() => {
    form.resetFields();
  }, [form]);

  useDetectHistoryNavigation(handleReset);

  return null;
};

const ResetFormOnHistoryChange = () => (
  <Item noStyle shouldUpdate>
    <ResetForm />
  </Item>
);

export default ResetFormOnHistoryChange;
